import * as React from 'react';
import styled from 'styled-components';

const getBorder = (props: ICardHeaderContainerProps): string => {
  if (props.borderless) return 'none';
  return `1px solid ${props.inverse ? 'var(--color-separator-inverse)' : 'var(--color-separator)'
    }`;
};

interface ICardHeaderContainerProps {
  inverse?: boolean;
  surface?: number;
  borderless?: boolean;
  noPadding?: boolean;
  containsTabs?: boolean;
  notRounded?: boolean;
}

export const CardHeaderContainer = styled.div<ICardHeaderContainerProps>`
  padding: ${(props: ICardHeaderContainerProps): string =>
    props.noPadding ? '0px' : '10px'};
  border-bottom: ${getBorder};
  flex: 0;
  display: flex;
  flex-direction: row;
  min-height: min-content;
  border-top-left-radius: ${(props: ICardHeaderContainerProps): string =>
    props.notRounded ? '0px' : '10px'};
  border-top-right-radius: ${(props: ICardHeaderContainerProps): string =>
    props.notRounded ? '0px' : '10px'};
  background-color: ${(props: ICardHeaderContainerProps): string =>
    typeof props.surface === 'number'
      ? `var(--color-surface-${props.surface})`
      : 'transparent'};
`;

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const CardHeaderWithListHeader = styled(CardHeaderContainer as any)`
  padding-bottom: 0px;
  padding-left: 0px;
  padding-right: 0px;
`;

export const CardHeaderCell = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
`;

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const CardHeaderRight = styled(CardHeaderCell as any)`
  justify-content: flex-end;
  position: relative;
`;

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const CardHeaderLeft = styled(CardHeaderCell as any)`
  justify-content: flex-start;
`;

interface IProps {
  withListHeader?: boolean;
  style?: React.CSSProperties;
  children: React.ReactNode;
  inverse?: boolean;
  surface?: number;
  borderless?: boolean;
  noPadding?: boolean;
  containsTabs?: boolean;
  notRounded?: boolean;
}

export const CardHeader = (props: IProps): React.ReactElement => {
  const Container = props.withListHeader
    ? CardHeaderWithListHeader
    : CardHeaderContainer;
  return (
    <Container
      style={props.style}
      inverse={props.inverse}
      surface={props.surface}
      borderless={props.borderless}
      noPadding={props.noPadding}
      containsTabs={props.containsTabs}
      notRounded={props.notRounded}
    >
      {props.children}
    </Container>
  );
};
